import { BudgetItem } from '../types';

/**
 * Pure functions for budget calculations - testable without Supabase
 */

/**
 * Calculates total planned amount from budget items
 */
export function calculateTotalPlanned(items: BudgetItem[]): number {
  return items.reduce((sum, item) => sum + (Number(item.planned_amount) || 0), 0);
}

/**
 * Calculates total paid amount from budget items
 */
export function calculateTotalPaid(items: BudgetItem[]): number {
  return items.reduce((sum, item) => sum + (Number(item.paid_amount) || 0), 0);
}

/**
 * Calculates remaining budget (planned - paid)
 */
export function calculateRemaining(planned: number, paid: number): number {
  return planned - paid;
}

/**
 * Filters budget items to only include those marked for budget inclusion
 */
export function filterIncludedItems(items: BudgetItem[]): BudgetItem[] {
  return items.filter(item => item.include_in_budget === true);
}

/**
 * Calculates budget summary from items
 */
export function calculateBudgetSummary(items: BudgetItem[]) {
  const includedItems = filterIncludedItems(items);
  const totalPlanned = calculateTotalPlanned(includedItems);
  const totalPaid = calculateTotalPaid(includedItems);
  const totalRemaining = calculateRemaining(totalPlanned, totalPaid);

  return {
    totalPlanned,
    totalPaid,
    totalRemaining,
    items: includedItems,
    itemsCount: includedItems.length,
  };
}
